const WEEKDAYS = {
  Mon: 1,
  Tue: 2,
  Wed: 3,
  Thu: 4,
  Fri: 5,
  Sat: 6,
  Sun: 7,
};

class CartDispatchMessage extends HTMLElement {
  connectedCallback() {
    this.#updateVisibility();
  }

  updatedCallback() {
    this.#updateVisibility();
  }

  #updateVisibility() {
    try {
      const now = this.#getStoreTime();
      this.hidden = this.#isHiddenWindow(now.day, now.hour);
    } catch {
      this.hidden = false;
    }
  }

  #getStoreTime() {
    const timezone = (this.dataset.timezone || "").trim();
    return timezone ? this.#timeFromIana(timezone) : this.#timeFromOffset(this.dataset.storeOffset);
  }

  #timeFromIana(timezone) {
    const parts = new Intl.DateTimeFormat("en-US", {
      timeZone: timezone,
      weekday: "short",
      hour: "numeric",
      hour12: false,
    }).formatToParts(new Date());

    const weekday = parts.find((part) => part.type === "weekday")?.value;
    const hourPart = parts.find((part) => part.type === "hour")?.value;
    const day = weekday ? WEEKDAYS[weekday] : undefined;
    let hour = Number.parseInt(hourPart || "", 10);

    if (!day || !Number.isInteger(hour)) throw new Error("Unable to resolve timezone");
    if (hour === 24) hour = 0;

    return { day, hour };
  }

  #timeFromOffset(offset) {
    const match = /^([+-])(\d{2})(\d{2})$/.exec((offset || "").trim());
    if (!match) throw new Error("Invalid store offset");

    const hours = Number.parseInt(match[2], 10);
    const minutes = Number.parseInt(match[3], 10);
    if (hours > 23 || minutes > 59) throw new Error("Invalid store offset");

    const sign = match[1] === "-" ? -1 : 1;
    const offsetMinutes = sign * (hours * 60 + minutes);
    const storeDate = new Date(Date.now() + offsetMinutes * 60_000);
    const jsDay = storeDate.getUTCDay();

    return {
      day: jsDay === 0 ? 7 : jsDay,
      hour: storeDate.getUTCHours(),
    };
  }

  #isHiddenWindow(day, hour) {
    const offDay = this.#dataInteger("offDay", 5, 1, 7);
    const offHour = this.#dataInteger("offHour", 9, 0, 23);
    const onDay = this.#dataInteger("onDay", 1, 1, 7);
    const onHour = this.#dataInteger("onHour", 9, 0, 23);
    const current = (day - 1) * 24 + hour;
    const start = (offDay - 1) * 24 + offHour;
    const end = (onDay - 1) * 24 + onHour;

    if (start <= end) return current >= start && current < end;
    return current >= start || current < end;
  }

  #dataInteger(name, fallback, minimum, maximum) {
    const value = Number.parseInt(this.dataset[name] || "", 10);
    return Number.isInteger(value) && value >= minimum && value <= maximum ? value : fallback;
  }
}

if (!customElements.get("cart-dispatch-message")) {
  customElements.define("cart-dispatch-message", CartDispatchMessage);
}
